module.exports = __webpack_public_path__ + "fonts/ProximaNova-Bold.1b598f34.eot";